module.exports = __webpack_public_path__ + "img/alex_competencies.d63f4597.svg";